import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';

import { UserConfigEffects } from '@store/effects/user-config.effects';
import { SettingsEffects } from '@store/effects/settings.effects';
import { FrameEffects } from '@store/effects/frame.effects';
import { AiEffects } from '@store/effects/ai.effects';
import { PaymentEffects } from '@store/effects/payment.effects';

import { userConfigReducer } from '@store/reducers/user-config.reducer';
import { settingsReducer } from '@store/reducers/settings.reduer';
import { frameReducer } from '@store/reducers/frame.reducer';
import { toolReducer } from '@store/reducers/tool.reducer';
import { aiReducer } from '@store/reducers/ai.reducer';
import { paymentReducer } from '@store/reducers/payment.reducer';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideStore({
      userConfig: userConfigReducer,
      settings: settingsReducer,
      frames: frameReducer,
      tools: toolReducer,
      ai: aiReducer,
      payment: paymentReducer,
    }),
    provideEffects([
      UserConfigEffects,
      SettingsEffects,
      FrameEffects,
      AiEffects,
      PaymentEffects,
    ]),
  ],
};
